import { atom } from "recoil";

export const idForDeleteAtom = atom({
  key: "idForDeleteAtom",
  default: [],
});
